import script from "./swiperComp.vue?vue&type=script&lang=ts&setup=true"
export * from "./swiperComp.vue?vue&type=script&lang=ts&setup=true"

import "./swiperComp.vue?vue&type=style&index=0&id=2f371198&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f371198"]])

export default __exports__